import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";
import { useNavigate } from 'react-router-dom';
import getBranchesList from '../../../utility/features/api_clients/reports/getBranchesList';
import getPostalCodebyBranchId from '../../../utility/features/api_clients/reports/getPostalCodeByBranch';
import getBranchDashBoardData from '../../../utility/features/api_clients/reports/getBranchDashBoardData';
import "./reports.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const Reports = () => {
    const navigate = useNavigate();
    const [appointments, setAppointments] = useState([
       
    ]);

    const [selectedBranch, setSelectedBranch] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedZipCode, setSelectedZipCode] = useState([]);
    const [zipCode, setZipCode] = useState('');
    const [postalCodes, setPostalCodes] = useState([]);
    const [loadingPostalCodes, setLoadingPostalCodes] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [branches, setBranches] = useState([]);
    const [loadingBranches, setLoadingBranches] = useState(true);
    const [loadingSearch, setLoadingSearch] = useState(false);

    // Fetch branches on component mount
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                setLoadingBranches(true); 
                const response = await getBranchesList();
                if (response && !response.error && response.data) {
                    setBranches(response.data);
                } else {
                    console.error('Failed to fetch branches:', response?.message);
                    setBranches([]);
                }
            } catch (error) {
                console.error('Error fetching branches:', error);
                setBranches([]);
            } finally {
                setLoadingBranches(false);
            }
        };

        fetchBranches();
    }, []);

    // Fetch postal codes when branch is selected
    useEffect(() => {
        const fetchPostalCodes = async () => {
            if (!searchTerm) {
                setPostalCodes([]);
                setSelectedZipCode([]);
                setZipCode('');
                return;
            }

            try {
                setLoadingPostalCodes(true);
                const response = await getPostalCodebyBranchId(searchTerm);
                if (response && !response.error && response.data) {
                    setPostalCodes(response.data);
                } else {
                    console.error('Failed to fetch postal codes:', response?.message);
                    setPostalCodes([]);
                }
            } catch (error) {
                console.error('Error fetching postal codes:', error);
                setPostalCodes([]);
            } finally {
                setLoadingPostalCodes(false);
            }
        };

        fetchPostalCodes();
    }, [searchTerm]);

    // Calculate min date for end date (1 day after start date)
    const getMinEndDate = () => {
        if (!startDate) return null;
        const minDate = new Date(startDate);
        minDate.setDate(minDate.getDate() + 1);
        return minDate;
    };

    // Calculate max date for end date (6 days after start date)
    const getMaxEndDate = () => {
        if (!startDate) return null;
        const maxDate = new Date(startDate);
        maxDate.setDate(maxDate.getDate() + 6);
        return maxDate;
    };

    // Filter dates for end date picker
    const filterEndDate = (date) => {
        if (!startDate) return false;
        const minDate = getMinEndDate();
        const maxDate = getMaxEndDate();
        return date >= minDate && date <= maxDate;
    };

    const getEndDateOpenToDate = () => {
        if (endDate) return endDate;
        if (startDate) return startDate;
        return undefined;
    };
    // Handle start date change
    const handleStartDateChange = (date) => {
        setStartDate(date);
        // Reset end date if it's outside the new valid range
        if (endDate) {
            const minDate = new Date(date);
            minDate.setDate(minDate.getDate() + 1);
            const maxDate = new Date(date);
            maxDate.setDate(maxDate.getDate() + 6);
            if (endDate < minDate || endDate > maxDate) {
                setEndDate(null);
            }
        }
    };
    const [activePage, setActivePage] = useState(1);
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(appointments?.length / ITEMS_PER_PAGE);
    const startIndex = (activePage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedAppointments = appointments?.slice(startIndex, endIndex);
    
    const handlePageClick = (pageNum) => {
        setActivePage(pageNum);
    };

    const handleSearch = async () => {
        // Validate required fields
        if (!searchTerm) {
            alert('Please select a branch');
            return;
        }

        setActivePage(1); // Reset to first page on search
        setLoadingSearch(true);

        try {
            // Format dates to YYYY-MM-DD
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Use current date as default if dates are not selected
            const currentDate = new Date();
            const finalStartDate = startDate || "";
            const finalEndDate = endDate || "";

            const requestData = {
                branchID: parseInt(searchTerm),
                startDate: finalEndDate ? formatDate(finalEndDate) : "", // Note: endDate is the earlier date (before start date)
                endDate: finalStartDate ? formatDate(finalStartDate) : ""
            };

            // Add postalCodeID if selected
            if (zipCode) {
                requestData.postalCodeID = zipCode;
            }

            const response = await getBranchDashBoardData(requestData);
            
            if (response && !response.error && response.data) {
                // Ensure response.data is an array
                const appointmentsData = Array.isArray(response.data) ? response.data : [];
                setAppointments(appointmentsData);
            } else {
                console.error('Failed to fetch appointments:', response?.message);
                alert(response?.message || 'Failed to fetch appointments');
                setAppointments([]);
            }
        } catch (error) {
            console.error('Error fetching appointments:', error);
            alert('An error occurred while fetching appointments');
            setAppointments([]);
        } finally {
            setLoadingSearch(false);
        }
    };

    const handleHolidaysClick = () => {
        // Add your holidays logic here
        navigate('/holidays');
    };

    const downloadReportHandler = () => {
        if (!appointments || appointments.length === 0) {
            alert('No appointments to download.');
            return;
        }

        // Map appointments to a flat structure for Excel
        const data = appointments.map((appointment) => ({
            'Branch ID': appointment.branchId || appointment.branchID || '',
            'Name': appointment.name || appointment.customerName || '',
            'Email': appointment.email || appointment.customerEmail || '',
            'Address': appointment.address || appointment.customerAddress || '',
            'Appt Date': appointment.apptDate || appointment.appointmentDate || '',
            'Appt Time': appointment.apptTime || appointment.appointmentTime || '',
            'Type': appointment.appoinmentType || '',
            'Phone Num': appointment.phoneNum || appointment.customerPhone || ''
        }));

        // Create worksheet and workbook
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Appointments');

        // Generate Excel file and trigger download
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const fileName = `appointments_report_${new Date().toISOString().slice(0,10)}.xlsx`;
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
    }

    return (
        <div className="container p-0">
            <div className="position-relative d-flex justify-content-between align-items-center">
            </div>
            <div className='row py-2'>
                <div className='col-12 col-md-3 mb-2 mb-md-0'>
                    <label className='form-label'>Search by Branch</label>
                    <div className="">
                        <Typeahead 
                            id="branch-typeahead"
                            labelKey={(option) => `${option.branchID || option.id}${option.branchName ? ` - ${option.branchName}` : ''}`}
                            options={branches}
                            placeholder={loadingBranches ? 'Loading branches...' : 'Select or search branch...'}
                            selected={selectedBranch}
                            inputProps={{ maxLength: 4 }}
                            onChange={(selected) => {
                                setSelectedBranch(selected);
                                const branchId = selected.length > 0 ? String(selected[0].branchID || selected[0].id) : '';
                                setSearchTerm(branchId);
                                // Reset zip code when branch changes
                                if (!branchId) {
                                    setSelectedZipCode([]);
                                    setZipCode('');
                                    setAppointments([]);
                                }
                            }}
                            disabled={loadingBranches}
                            clearButton
                            emptyLabel="No branches found"
                            positionFixed
                        />
                    </div>
                </div>
                <div className='col-12 col-md-3 mb-2 mb-md-0'>
                    <label className='form-label'>Zip Code</label>
                    <div className="">
                        <Typeahead 
                            id="zipcode-typeahead"    inputProps={{ maxLength: 5 }}
                            labelKey={(option) => String(option.postalCodeID || option.zipCode || option)}
                            options={postalCodes}
                            placeholder={loadingPostalCodes ? 'Loading zip codes...' : !searchTerm ? 'Select branch first' : 'Select or search zip code...'}
                            selected={selectedZipCode}
                            onChange={(selected) => {
                                setSelectedZipCode(selected);
                                setZipCode(selected.length > 0 ? String(selected[0].postalCodeID || selected[0].zipCode || selected[0]) : '');
                            }}
                            disabled={loadingPostalCodes || !searchTerm}
                            clearButton
                            emptyLabel="No zip codes found"
                            positionFixed
                        />
                    </div>
                </div>
                <div className='col-12 col-md-2 mb-2 mb-md-0'>
                    <label className='form-label'>Start Date</label>
                    <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        className='form-control'
                        wrapperClassName='w-100'
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select start date"
                        // minDate={new Date(new Date().setDate(new Date().getDate() - 6))}
                        maxDate={new Date()}
                        showIcon 
                        toggleCalendarOnIconClick
                        calendarIconClassName='react-datepicker__calendar-icon'
                    />
                </div>
                <div className='col-12 col-md-2 mb-2 mb-md-0'>
                    <label className='form-label'>End Date</label>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className='form-control'
                        wrapperClassName='w-100'
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select end date"
                        disabled={!startDate}
                                                openToDate={getEndDateOpenToDate()}
                        filterDate={filterEndDate}
                        minDate={getMinEndDate()}
                        // openToDate={getEndDateOpenToDate()}
                          maxDate={new Date()}
                        showIcon 
                        toggleCalendarOnIconClick
                        calendarIconClassName='react-datepicker__calendar-icon'
                    />
                </div>
                <div className='col-12 col-md-2 mb-2 mb-md-0'>
                    <label className='form-label'>&nbsp;</label>
                    <button
                        type="button"
                        className={`btn btn-primary w-100 ${appointmentStyles["bg-green"]}`}
                        onClick={handleSearch}
                        disabled={loadingSearch || !searchTerm}
                    >
                        {loadingSearch ? 'Searching...' : 'Search'}
                    </button>
                </div>
                
            </div>
            {appointments.length > 0 ? <div className='col-12 d-flex justify-content-end'>
                <div className='col-md-2 py-2'>
                    <button
                        type="button"
                        className={`btn btn-primary w-100 ${appointmentStyles["bg-green"]}`}
                        onClick={downloadReportHandler}
                        disabled={loadingSearch || !searchTerm}
                    > Download Report
                    </button>
                </div>
            </div> : null}


            {/* </div> */}

            <div className={appointmentStyles["table-theme"]}>
                <div className={`table-responsive ${appointmentStyles["table-card"]}`}>
                    <table className={`w-100 ${appointmentStyles["table"]} align-middle`}>
                        <thead>
                            <tr>
                                <th scope="col">Branch ID</th>
                                <th scope="col" className="compact-name">Name</th>
                                <th scope="col" className="compact-email">Email</th>
                                <th scope="col" className="compact-address">Address</th>
                                <th scope="col">Appt Date – Time – (Type)</th>
                                <th scope="col">Phone Num</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingSearch ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">
                                        Loading appointments...
                                    </td>
                                </tr>
                            ) : appointments.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">
                                       Please adjust your search filters to see the appointments.
                                    </td>
                                </tr>
                            ) : (
                                paginatedAppointments.map((appointment, index) => {
                                    return (
                                        <tr key={`${appointment.branchId || appointment.branchID}-${index}`}>
                                            <td>{appointment.branchId || appointment.branchID}</td>
                                            <td className="compact-name" title={appointment.name || appointment.customerName}>{appointment.name || appointment.customerName}</td>
                                            <td className="compact-email" title={appointment.email || appointment.customerEmail}>{appointment.email || appointment.customerEmail}</td>
                                            <td className="compact-address" title={appointment.address || appointment.customerAddress}>{appointment.address || appointment.customerAddress}</td>
                                            <td>{appointment.apptDate || appointment.appointmentDate} – {appointment.apptTime || appointment.appointmentTime} ({appointment.appoinmentType})</td>
                                            <td>{appointment.phoneNum || appointment.customerPhone}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {totalPages > 1 && (
                <div className={appointmentStyles['pagination-wrapper']}>
                    <div className={appointmentStyles['pagination']}>
                        <button 
                            className={`${appointmentStyles["page-btn"]} ${appointmentStyles['nav-btn']}`} 
                            onClick={() => handlePageClick(activePage - 1)}
                            disabled={activePage === 1}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>

                        {activePage > 3 && (
                            <>
                                <button className={appointmentStyles["page-btn"]} onClick={() => handlePageClick(1)}>1</button>
                                {activePage > 4 && <span className={appointmentStyles["ellipsis"]}>...</span>}
                            </>
                        )}

                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter((num) => num >= activePage - 2 && num <= activePage + 2)
                            .map((num) => (
                                <button 
                                    key={num} 
                                    className={`${appointmentStyles["page-btn"]} ${num === activePage ? appointmentStyles["active"] : ""}`} 
                                    onClick={() => handlePageClick(num)}
                                >
                                    {num}
                                </button>
                            ))}

                        {activePage < totalPages - 2 && (
                            <>
                                {activePage < totalPages - 3 && <span className={appointmentStyles["ellipsis"]}>...</span>}
                                <button className={appointmentStyles["page-btn"]} onClick={() => handlePageClick(totalPages)}>{totalPages}</button>
                            </>
                        )}

                        <button 
                            className={`${appointmentStyles["page-btn"]} ${appointmentStyles['nav-btn']}`} 
                            onClick={() => handlePageClick(activePage + 1)}
                            disabled={activePage === totalPages}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <div className={appointmentStyles['pagination-info']}>
                        <span>Showing {startIndex + 1} - {Math.min(endIndex, appointments?.length)} of {appointments?.length} appointments</span>
                    </div>
                </div>
            )}
        </div>
    );
};


export default Reports;